export default {"src":"/_next/static/media/0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68.e2ce43be.svg","height":2346,"width":2346,"blurWidth":0,"blurHeight":0};